<template>
  <v-card
    class="card py-12"
    :min-height="settings.bg && settings.bg.height ? settings.bg.height : '500px'"
    elevation="0"
    tile
    :color="MIXIN_getBgInfo(settings, 'color')"
    :img="MIXIN_getBgInfo(settings, 'image')"
  >
    <section class="d-flex flex-column flex align-center justify-center">
      <div>
        <title-component :id="id" :settings="{...settingsTitle, idLayout: settings.idLayout}" />
      </div>

      <div class="pt-6" style="max-width: 90% !important;">
        <layout-2
          v-if="settings.layout === 'Layout 2'"
          :formattedFaqs="formattedFaqs"
          :settings="settings"
        />

        <layout-1
          v-if="settings.layout === 'Layout 1'"
          :formattedFaqs="formattedFaqs"
          :settings="settings"
        />
      </div>
    </section>
  </v-card>
</template>

<script>
import TitleComponent from "../title/TitleComponent.vue";
import { mapGetters } from "vuex";
import Layout2 from "./layouts/Layout2.vue";
import Layout1 from "./layouts/Layout1.vue";
import { GetLayoutSectionMixin } from "../../mixins/GetLayoutSection"

export default {
  mixins: [GetLayoutSectionMixin],  
  components: { TitleComponent, Layout2, Layout1 },
  props: {
    id: {type: String},
    settings: {
      type: Object,
    },
  },

  data() {
    return {
      settingsTitle: null,
      hover: false,
      expandeds: [],
      formattedFaqs: [],
    };
  },

  computed: {
    ...mapGetters(["faq"]),
  },

  created() {
    this.settingsTitle = {
      title: this.settings.title,
      subtitle: this.settings.subtitle,
      "background-color": "transparent",
    };

    this.isFaqLoaded()
  },

  methods: {
    isFaqLoaded () {
      if (this.faq && this.faq.length > 0) {
        this.formattedFaqs = this.faq.map((f) => {
          return { ...f, expandeds: [], groupExpandeds: [] };
        });
        this.$forceUpdate()
      }
    }
  },

  watch: {
    faq: {
      deep: true,
      handler () {
        this.isFaqLoaded()
      }
    }
  },
};
</script>

<style scoped>
.card {
  display: flex;
  flex-direction: column;
}

h1 {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
  letter-spacing: 0.25px;
  text-align: left;
}

span {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
}
</style>

<style>
.answer-html > p {
  margin: 0px !important;
  padding: 0px !important;
}
</style>
